"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = exports.ToastProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_react_1 = require("lucide-react");
const react_1 = require("react");
const ToastContext = (0, react_1.createContext)(() => undefined);
// Operator feedback for actions whose effect is not visible on the page they
// were taken on (a vendor switch, the pause, a queued re-send).
const DISMISS_AFTER_MS = 8000;
const VARIANT_CLASSES = {
    success: 'border-success-fg/40',
    error: 'border-destructive/60',
    info: '',
};
const DOT_CLASSES = {
    success: 'bg-success-fg',
    error: 'bg-destructive',
    info: 'bg-muted-foreground',
};
const ToastCard = ({ item, onClose }) => {
    const variant = item.variant ?? 'info';
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => onClose(item.id), DISMISS_AFTER_MS);
        return () => clearTimeout(timer);
    }, [item.id, onClose]);
    return ((0, jsx_runtime_1.jsxs)("div", { role: variant === 'error' ? 'alert' : 'status', className: `pointer-events-auto flex w-[360px] max-w-[calc(100vw-2rem)] gap-2.5 rounded-lg border bg-card p-3.5 shadow-lg ${VARIANT_CLASSES[variant]}`, children: [(0, jsx_runtime_1.jsx)("span", { className: `mt-1.5 size-2 shrink-0 rounded-full ${DOT_CLASSES[variant]}` }), (0, jsx_runtime_1.jsxs)("div", { className: "min-w-0 flex-1", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-[13px] font-medium", children: item.title }), item.description && (0, jsx_runtime_1.jsx)("p", { className: "mt-0.5 text-xs text-muted-foreground", children: item.description })] }), (0, jsx_runtime_1.jsx)("button", { type: "button", "aria-label": "close", onClick: () => onClose(item.id), className: "h-5 shrink-0 text-muted-foreground hover:text-foreground", children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { className: "size-3.5" }) })] }));
};
const ToastProvider = ({ children }) => {
    const [items, setItems] = (0, react_1.useState)([]);
    const nextId = (0, react_1.useRef)(1);
    const close = (0, react_1.useCallback)((id) => setItems((prev) => prev.filter((item) => item.id !== id)), []);
    const toast = (0, react_1.useCallback)((input) => {
        const id = nextId.current++;
        setItems((prev) => [...prev.slice(-3), { ...input, id }]);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(ToastContext.Provider, { value: toast, children: [children, (0, jsx_runtime_1.jsx)("div", { "aria-live": "polite", className: "pointer-events-none fixed bottom-4 right-4 z-[100] flex flex-col gap-2", children: items.map((item) => ((0, jsx_runtime_1.jsx)(ToastCard, { item: item, onClose: close }, item.id))) })] }));
};
exports.ToastProvider = ToastProvider;
const useToast = () => (0, react_1.useContext)(ToastContext);
exports.useToast = useToast;
